module.exports = __webpack_public_path__ + "img/i_5.5085437e.png";